// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2HUb2","content":"LayoutSettings_content__17vLu"};